import Vue from 'vue'
import Router from 'vue-router'
import Report from './report.js'
import Alarm from './alarm.js'
import PlatformRouter from './platform.js'
import OpeationRouter from './operation.js'
import ServerRouter from './server.js'
import companyRouter from './viewCompany.js'
import systemRouter from './systemConfig.js'
import activeSafetyRouter from './activeSafety.js'
import russiaRouter from './russia.js'
import TaxiRouter from './taxi.js'
import AppRouter from './app.js'
import AllRouter from './all.js'
Vue.use(Router)

const Index = (resolve) => {
  import('components/index/index').then((module) => {
    resolve(module)
  })
}

const Login = (resolve) => {
  import('components/login/login').then((module) => {
    resolve(module)
  })
}

// const Home = (resolve) => {
//   import('components/home/home').then((module) => {
//     resolve(module)
//   })
// }

const Shortcuts = (resolve) => {
  import('components/shortcuts/shortcuts').then((module) => {
    resolve(module)
  })
}

const Home = (resolve) => {
  import('components/newHome/newHome').then((module) => {
    resolve(module)
  })
}

const RealTimeMonitor = (resolve) => {
  import('components/realTimeMonitor/realTimeBase').then((module) => {
    resolve(module)
  })
}

const alarmDetailPage = (resolve) => {
  import('components/realTimeMonitor/alarmDetailPage').then((module) => {
    resolve(module)
  })
}

const PathPlayBack = (resolve) => {
  import('components/pathPlayBack/pathPlayBack').then((module) => {
    resolve(module)
  })
}

const VideoQuery = (resolve) => {
  import('components/videoQuery/videoQuery').then((module) => {
    resolve(module)
  })
}

const VideoQueryCanvas = (resolve) => {
  import('components/videoQuery/videoQueryCanvas').then((module) => {
    resolve(module)
  })
}

const Platform = (resolve) => {
  import('components/platform/platform').then((module) => {
    resolve(module)
  })
}

const Reports = (resolve) => {
  import('components/reports/reports').then((module) => {
    resolve(module)
  })
}

const Alarms = (resolve) => {
  import('components/alarm/alarm').then((module) => {
    resolve(module)
  })
}

const Operation = (resolve) => {
  import('components/operation/operation').then((module) => {
    resolve(module)
  })
}

const Server = (resolve) => {
  import('components/server/server').then((module) => {
    resolve(module)
  })
}

const viewCompany = (resolve) => {
  import('components/viewCompany/viewCompany').then((module) => {
    resolve(module)
  })
}

const MapPage = (resolve) => {
  import('components/realTimeMonitor/mapPage').then((module) => {
    resolve(module)
  })
}

const VideoPage = (resolve) => {
  import('components/realTimeMonitor/videoPage').then((module) => {
    resolve(module)
  })
}

const videoPageCanvas = (resolve) => {
  import('components/realTimeMonitor/videoPageCanvas').then((module) => {
    resolve(module)
  })
}

const SystemConfig = (resolve) => {
  import('components/systemConfig/systemConfig').then((module) => {
    resolve(module)
  })
}

const ActiveSafety = (resolve) => {
  import('components/activeSafety/activeSafety').then((module) => {
    resolve(module)
  })
}

// 中俄
const Russia = (resolve) => {
  import('components/russia/russia').then((module) => {
    resolve(module)
  })
}

// 主动安全实时数据监控平台
const ASRealTimePlatform = (resolve) => {
  import('components/newHome/ASRealTimePlatform').then((module) => {
    resolve(module)
  })
}

// 固件首页
const FirmwareHome = (resolve) => {
  import('components/newHome/firmwareHome').then((module) => {
    resolve(module)
  })
}

// 出租车24小时上下客热力图
const TaxiHeatmap = (resolve) => {
  import('components/newHome/taxiHeatmap').then((module) => {
    resolve(module)
  })
}

const Taxi = (resolve) => {
  import('components/taxi/taxi').then((module) => {
    resolve(module)
  })
}

const App = (resolve) => {
  import('components/app/app').then((module) => {
    resolve(module)
  })
}

const All = (resolve) => {
  import('components/all/all').then((module) => {
    resolve(module)
  })
}
// // 主动安全主页
// const activeSafetyHomePage = (resolve) => {
//   import('components/activeSafety/activeSafetyHomePage').then((module) => {
//     resolve(module)
//   })
// }

// // 主动安全总览
// const activeSafetyOverview = (resolve) => {
//   import('components/activeSafety/activeSafety.overview').then((module) => {
//     resolve(module)
//   })
// }
// 每日报告
const dailyReport = (resolve) => {
  import('components/newHome/dailyReport').then((module) => {
    resolve(module)
  })
}

let router = new Router({
  routes: [{
    path: '/',
    redirect: '/login'
  },
    // 登录
  {
    path: '/login',
    component: Login,
    meta: {
      allowBack: false // 禁止回退
    }
  },
  // 日报
  {
    path: '/dailyReport',
    component: dailyReport
  },
  // 快捷应用
  {
    path: '/shortcuts',
    component: Shortcuts
  },
  // 首页
  {
    path: '/home',
    component: Home
  },
  // 主动安全实时数据监控平台
  {
    path: '/ASRealTimePlatform',
    component: ASRealTimePlatform
  },
  // 固件首页
  {
    path: '/firmwareHome',
    component: FirmwareHome
  },
  // 出租车24小时上下客热力图
  {
    path: '/taxiHeatmap',
    component: TaxiHeatmap
  },
  {
    path: '/index',
    component: Index,
    children: [
      // 实时监控
      {
        path: 'realTimeMonitor',
        component: RealTimeMonitor,
        children: [{
          path: 'mapPage', // 实时监控
          component: MapPage
        },
        {
          path: 'videoPage', // 视频监控
          component: VideoPage
        },
        {
          path: 'videoPageCanvas', // H265视频监控
          component: videoPageCanvas
        }
        ]
      },
      // 车辆报警位置及详情
      {
        path: 'realTimeMonitor/alarmDetailPage',
        name: 'alarmDetailPage',
        component: alarmDetailPage
      },
      // 轨迹回放
      {
        path: 'pathPlayBack',
        name: 'pathPlayBack',
        component: PathPlayBack
      },
      // 录像查询
      {
        path: 'videoQuery',
        component: VideoQuery
      },
      // H265录像查询
      {
        path: 'VideoQueryCanvas',
        component: VideoQueryCanvas
      },
      // 平台功能
      {
        path: 'platform',
        component: Platform,
        children: PlatformRouter.platformPath
      },
      // 报表统计
      {
        path: 'reports',
        component: Reports,
        children: Report.reportPath
      },
      // 报警统计
      {
        path: 'alarms',
        component: Alarms,
        children: Alarm.alarmPath
      },
      // 出租车报表
      {
        path: 'taxi',
        component: Taxi,
        children: TaxiRouter.taxiPath
      },
      // 运营管理
      {
        path: 'operation',
        component: Operation,
        children: OpeationRouter.operationPath
      },
      // 服务器管理
      {
        path: 'server',
        component: Server,
        children: ServerRouter.serverPath
      },
      // 查看公司
      {
        path: 'viewCompany',
        component: viewCompany,
        children: companyRouter.viewCompanyPath
      },
      // 系统配置
      {
        path: 'systemConfig',
        component: SystemConfig,
        children: systemRouter.systemConfigPath
      },
      // 主动安全
      {
        path: 'activeSafety', // 菜单
        component: ActiveSafety,
        children: activeSafetyRouter.activeSafetyPath
      },
      // {
      //   path: 'activeSafetyHomePage',
      //   component: activeSafetyHomePage,
      //   children: [
      //     {
      //       path: '/activeSafety/overview', // 安全总览
      //       component: activeSafetyOverview
      //     },
      //     {
      //       path: 'activeSafety', // 菜单
      //       component: ActiveSafety,
      //       children: activeSafetyRouter.activeSafetyPath
      //     }
      //   ]
      // },
      // 中俄
      {
        path: 'russia',
        component: Russia,
        children: russiaRouter.russiaPath
      },
      // APP管理
      {
        path: 'russia',
        component: App,
        children: AppRouter.appPath
      },
      // 所有
      {
        path: 'all',
        component: All,
        children: AllRouter.allPath
      }
    ]
  },
  {
    path: '*',
    redirect: '/'
  }
  ]
})
// router.beforeEach((to, from, next) => {
//   console.log(to)
//   console.log(from)
//   console.log(document)
//   if (to.meta.allowBack !== undefined && !to.meta.allowBack) {
//     history.pushState(null, null, document.URL)
//     window.addEventListener('popstate', function () {
//       console.log('popstate')
//       history.pushState(null, null, document.URL)
//     }, false)
//   }
//   next()
// })
export default router



// WEBPACK FOOTER //
// ./src/router/index.js